import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step6 } from '../../../../../shared/models/component-messages/diveIN/step6';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { TypeAnn_DIVER_G1 } from '../../models/TypeAnn_DIVER_G1';
import { TypeDelaisDivers } from '../../models/TypeDelaisDivers';

@Component({
	selector: 'app-step6',
	templateUrl: './step6.component.html'
})
export class Step6Component implements OnInit {

	private LOG: LogService = new LogService(Step6Component);

	@Input() initial: TypeAnn_DIVER_G1;
	@Input() delais: TypeDelaisDivers;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;

	public current_uid = 'rens_compl'
	public step6 = new Step6();

	constructor(
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private formUtilsService: FormUtilsService
	) { }

	ngOnInit(): void {
	}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	  }  

}
